<app-header-top *ngIf="!isPVendita" [title]="'Varianti'"></app-header-top>


<!-- Lista dei prodotti -->
<div class="mt-3"
     [class.container-target]="!isModal"
     [class.px-4]="isModal">
   <dx-data-grid #grid>

      <dxo-header-filter [visible]="true"></dxo-header-filter>

      <dxi-column cellTemplate="cellButtonTemplate"></dxi-column>

      <div *dxTemplate="let cellInfo of 'cellButtonTemplate'">
         <button *ngIf="isPVendita" class="btn-tbl"
                 (click)="clickSelectVariant(cellInfo.data)">
            <i class="fa-solid fa-check"></i>
         </button>
         <button *ngIf="!isPVendita" class="btn-tbl icon-modifica" [routerLink]="isVendor ?
                ['/ng/e/'+vendorSlug+'/prodotti/'+cellInfo.data.prodotto.id+'/pvarianti/'+cellInfo.data.id] :
                ['/admin/prodotti/'+cellInfo.data.prodotto.id+'/pvarianti/'+cellInfo.data.id]">
         </button>
      </div>

      <dxi-column *ngIf="isModal" dataField="qta" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Qta" [hidden]="!pVenditaID"></dxi-column>
      <dxi-column dataField="codice" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Codice"></dxi-column>
      <dxi-column dataField="colore_nome" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Colore"></dxi-column>
      <dxi-column dataField="brand" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Brand"></dxi-column>
      <dxi-column dataField="prodotto.nome" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Nome"></dxi-column>
      <dxi-column dataField="prodotto.stagione" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Stagione"></dxi-column>
      <dxi-column dataField="prodotto.year" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Anno"></dxi-column>
      <dxi-column dataField="prodotto.target_sesso" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Genere"></dxi-column>
      <dxi-column dataField="prodotto.target_eta" [allowHeaderFiltering]="false" [allowFiltering]="true" caption="Età"></dxi-column>

      <dxi-column dataField="is_approved" caption="Approvato" width="120" [allowHeaderFiltering]="false" [allowFiltering]="true"
                  dataType="boolean" cellTemplate="approvaTemplate" *ngIf="!isVendor"></dxi-column>
      <div *dxTemplate="let cellInfo of 'approvaTemplate'">
         <button [ngClass]="!cellInfo.data.is_confirmed ?
                     'btn-green approva' :
                     'btn-red disapprova'"
                 class="btn-small justify-center w-full "
                 (click)="clickApprovaVariante(cellInfo)">
         </button>
      </div>

   </dx-data-grid>
</div>
